import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { EmployeeDetail } from 'app/shared/models/evilo-models';
import { DataShareService } from '../../../../services/data-share.service';
import { AccountMembership, Team } from '../../../../models';
import { FieldType } from '@ngx-formly/core';
import { NgSelectComponent, NgLoadingSpinnerTemplateDirective } from '@ng-select/ng-select';

@Component({
    selector: 'app-select-team',
    templateUrl: './select-team.component.html',
    styleUrls: ['./select-team.component.scss'],
    imports: [NgSelectComponent, NgLoadingSpinnerTemplateDirective]
})
export class SelectTeamComponent extends FieldType implements OnInit {
  allTeamSubscription;
  allTeams : Team[] = []

  employees$: Observable<EmployeeDetail[]>;
  teamLoading = false;
  employeeInput$ = new Subject<string>();
  @Input() placeholder: string = "Please select associated employee";
  @Input() allowMultiple: boolean = false;
  @Input() allowAdding: boolean = false;
  @Output()selectedTeams= new EventEmitter();

  constructor(private dataService: DataShareService,) { 
    super();
  }

  ngOnInit() {
    // this.loadEmployees();
    this.allTeamSubscription = this.dataService.getTeams().subscribe((param: any) => {
      if (param) {
        this.allTeams = param;
      }
    })
  }

  ngOnDestroy(): void {
    if (this.allTeamSubscription && !this.allTeamSubscription.closed)
      this.allTeamSubscription.unsubscribe();
  }

  trackByFnTeam(item: Team) {
    return item.id
  }

  onTeamSelectChange(event) {
    console.log("selection changed: added ", event);
    if (event) {
      this.selectedTeams.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(event.id)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
    }
  }

  onTeamSelectRemove(event) {
    console.log("selection removed: removed ", event);
      this.selectedTeams.emit(event);
      if (this.field && this.field.templateOptions) {
        this.formControl.setValue(event.id)
        // this.field.templateOptions.onContactSelectionChange(event);
        // console.log("the field : ", JSON.stringify(this.field))
      }
  }

}
